import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilogixDetailsForm from "../../../util-components/filogix/filogix-details-form.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import ImportFromExpertModal from "./import-from-expert-modal.vue";
import { cloneDeep } from "lodash";
import SyncedWithExpertStatus from "./synced-with-expert-status.vue";
import { defineComponent } from "@vue/composition-api";
import { GET_MPP_GENERATE } from "@Broker/@Modules/main/store/account/account-getters";
import { mapGetters } from "vuex";
export default defineComponent({
  name: "FilogixDetails",
  components: {
    FilogixDetailsForm,
    SimpleButton,
    ImportFromExpertModal,
    SyncedWithExpertStatus
  },
  props: {
    filogixData: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    allowSave: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      filogixDetails: cloneDeep(this.filogixData)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [GET_MPP_GENERATE])), {}, {
    syncFromExpertTooltipText() {
      return this.allowSave ? this.$t("settings.accountTab.saveToSync") : this.$t("settings.accountTab.importExpertTooltip");
    },
    isMppEnabled() {
      return this.GET_MPP_GENERATE;
    }
  }),
  methods: {
    handleSubmit() {
      this.$emit("submit", this.filogixDetails);
    },
    handleFormChange() {
      this.$emit("allow-save", true);
    },
    importFromExpert() {
      this.filogixDetails = cloneDeep(this.filogixData);
      this.$refs.importFromExpertModal.$showModal();
    },
    updateExpertProfileNumber(value) {
      this.filogixDetails = value;
      this.handleFormChange();
    },
    updateLenderSubmissionDetails() {
      this.filogixDetails = cloneDeep(this.filogixData);
    }
  }
});